/*
 * Formula Scoop Calculator — scoop-calc.js
 * Upload: Shopify Admin → Themes → Edit code → Assets → scoop-calc.js
 * Connect: templates/article.liquid:
 *   <script src="{{ 'scoop-calc.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  var root = document.getElementById('sc-root');
  if (!root) return;

  /*
   * Formula database: grams per scoop, ml of water per scoop
   * Sources: manufacturer packaging + OLS preparation instructions page
   * Most EU formulas: 1 scoop per 30ml water (1 oz)
   * Some exceptions noted below
   */
  var formulas = {
    // HiPP Dutch
    hipp_dutch_1:     { g: 4.6, ml: 30, name: 'HiPP Dutch Stage 1' },
    hipp_dutch_2:     { g: 4.7, ml: 30, name: 'HiPP Dutch Stage 2' },
    hipp_dutch_3:     { g: 4.7, ml: 30, name: 'HiPP Dutch Stage 3' },
    // HiPP German
    hipp_german_pre:  { g: 4.3, ml: 30, name: 'HiPP German PRE' },
    hipp_german_1:    { g: 4.5, ml: 30, name: 'HiPP German Stage 1' },
    hipp_german_2:    { g: 4.6, ml: 30, name: 'HiPP German Stage 2' },
    hipp_german_3:    { g: 4.7, ml: 30, name: 'HiPP German Stage 3' },
    // HiPP UK
    hipp_uk_1:        { g: 4.5, ml: 30, name: 'HiPP UK Stage 1' },
    hipp_uk_2:        { g: 4.6, ml: 30, name: 'HiPP UK Stage 2' },
    // HiPP HA
    hipp_ha_pre:      { g: 4.3, ml: 30, name: 'HiPP HA PRE' },
    hipp_ha_1:        { g: 4.4, ml: 30, name: 'HiPP HA Stage 1' },
    hipp_ha_2:        { g: 4.5, ml: 30, name: 'HiPP HA Stage 2' },
    hipp_ha_dutch_1:  { g: 4.4, ml: 30, name: 'HiPP HA Dutch Stage 1' },
    // HiPP Specialty
    hipp_comfort:     { g: 4.6, ml: 30, name: 'HiPP Comfort' },
    hipp_ar:          { g: 4.5, ml: 30, name: 'HiPP Anti-Reflux' },
    // HiPP Goat
    hipp_goat_1:      { g: 4.5, ml: 30, name: 'HiPP Dutch Goat Stage 1' },
    hipp_goat_2:      { g: 4.6, ml: 30, name: 'HiPP Dutch Goat Stage 2' },
    hipp_goat_3:      { g: 4.7, ml: 30, name: 'HiPP Dutch Goat Stage 3' },
    // Holle Bio
    holle_bio_pre:    { g: 4.3, ml: 30, name: 'Holle Bio PRE' },
    holle_bio_1:      { g: 4.3, ml: 30, name: 'Holle Bio Stage 1' },
    holle_bio_2:      { g: 4.5, ml: 30, name: 'Holle Bio Stage 2' },
    holle_bio_3:      { g: 4.5, ml: 30, name: 'Holle Bio Stage 3' },
    holle_bio_4:      { g: 4.5, ml: 30, name: 'Holle Bio Stage 4' },
    // Holle Goat
    holle_goat_pre:   { g: 4.3, ml: 30, name: 'Holle Goat PRE' },
    holle_goat_1:     { g: 4.3, ml: 30, name: 'Holle Goat Stage 1' },
    holle_goat_2:     { g: 4.5, ml: 30, name: 'Holle Goat Stage 2' },
    holle_goat_3:     { g: 4.5, ml: 30, name: 'Holle Goat Stage 3' },
    // Holle A2
    holle_a2_1:       { g: 4.3, ml: 30, name: 'Holle A2 Stage 1' },
    holle_a2_2:       { g: 4.5, ml: 30, name: 'Holle A2 Stage 2' },
    holle_a2_3:       { g: 4.5, ml: 30, name: 'Holle A2 Stage 3' },
    // Kendamil (all stages use 4.3g scoop)
    kendamil_organic_1: { g: 4.3, ml: 30, name: 'Kendamil Organic Stage 1' },
    kendamil_organic_2: { g: 4.3, ml: 30, name: 'Kendamil Organic Stage 2' },
    kendamil_organic_3: { g: 4.3, ml: 30, name: 'Kendamil Organic Stage 3' },
    kendamil_classic_1: { g: 4.3, ml: 30, name: 'Kendamil Classic Stage 1' },
    kendamil_classic_2: { g: 4.3, ml: 30, name: 'Kendamil Classic Stage 2' },
    kendamil_classic_3: { g: 4.3, ml: 30, name: 'Kendamil Classic Stage 3' },
    kendamil_goat_1:    { g: 4.3, ml: 30, name: 'Kendamil Goat Stage 1' },
    kendamil_goat_2:    { g: 4.3, ml: 30, name: 'Kendamil Goat Stage 2' },
    kendamil_goat_3:    { g: 4.3, ml: 30, name: 'Kendamil Goat Stage 3' },
    // Lebenswert
    lebenswert_1:     { g: 4.3, ml: 30, name: 'Lebenswert Stage 1' },
    lebenswert_2:     { g: 4.5, ml: 30, name: 'Lebenswert Stage 2' },
    lebenswert_3:     { g: 4.5, ml: 30, name: 'Lebenswert Stage 3' },
    // Nannycare
    nannycare_1:      { g: 4.3, ml: 30, name: 'Nannycare Stage 1' },
    nannycare_2:      { g: 4.5, ml: 30, name: 'Nannycare Stage 2' },
    nannycare_3:      { g: 4.5, ml: 30, name: 'Nannycare Stage 3' },
    // Aptamil
    aptamil_pepti_1:  { g: 4.4, ml: 30, name: 'Aptamil Pepti Stage 1' },
    aptamil_pepti_2:  { g: 4.5, ml: 30, name: 'Aptamil Pepti Stage 2' },
    aptamil_comfort:  { g: 4.6, ml: 30, name: 'Aptamil Comfort' }
  };

  // Constants
  var GRAMS_PER_TSP = 1.25;  // level tsp of formula powder
  var GRAMS_PER_TBSP = 3.75; // level tbsp of formula powder
  var ML_PER_OZ = 29.5735;

  var selectEl = document.getElementById('sc-formula');
  var infoEl = document.getElementById('sc-info');
  var step2El = document.getElementById('sc-step2');
  var resultEl = document.getElementById('sc-result');
  var bottleEl = document.getElementById('sc-bottle');
  var unitEl = document.getElementById('sc-unit');
  var calcBtn = document.getElementById('sc-calc-btn');

  var selected = null;

  // Formula selection handler
  if (selectEl) {
    selectEl.addEventListener('change', function () {
      var key = this.value;
      if (!key || !formulas[key]) {
        infoEl.style.display = 'none';
        step2El.style.display = 'none';
        resultEl.style.display = 'none';
        selected = null;
        return;
      }

      selected = formulas[key];

      // Show scoop info
      document.getElementById('sc-grams').textContent = selected.g + 'g';
      document.getElementById('sc-tsp').textContent = '~' + (selected.g / GRAMS_PER_TSP).toFixed(1);
      document.getElementById('sc-tbsp').textContent = '~' + (selected.g / GRAMS_PER_TBSP).toFixed(1);
      document.getElementById('sc-ratio').textContent = '1 : ' + selected.ml + 'ml';

      infoEl.style.display = 'block';
      step2El.style.display = 'block';
      resultEl.style.display = 'none';

      // Clear previous result
      bottleEl.value = '';
    });
  }

  // Calculate handler
  if (calcBtn) {
    calcBtn.addEventListener('click', function () {
      if (!selected) return;

      var val = parseFloat(bottleEl.value);
      if (!val || val <= 0 || val > 500) return;

      var unit = unitEl.value;
      var waterMl = unit === 'oz' ? val * ML_PER_OZ : val;

      // How many scoops
      var scoops = waterMl / selected.ml;
      var totalGrams = scoops * selected.g;
      var totalTbsp = totalGrams / GRAMS_PER_TBSP;
      var totalTsp = totalGrams / GRAMS_PER_TSP;

      // Display
      document.getElementById('sc-r-grams').textContent = totalGrams.toFixed(1) + 'g';
      document.getElementById('sc-r-scoops').textContent = scoops.toFixed(1);
      document.getElementById('sc-r-tbsp').textContent = '~' + totalTbsp.toFixed(1);
      document.getElementById('sc-r-tsp').textContent = '~' + totalTsp.toFixed(1);

      var waterDisplay = unit === 'oz'
        ? val + ' oz (' + Math.round(waterMl) + ' ml)'
        : val + ' ml (' + (val / ML_PER_OZ).toFixed(1) + ' oz)';

      document.getElementById('sc-r-water').textContent =
        'Add ' + totalGrams.toFixed(1) + 'g of ' + selected.name + ' powder to ' + waterDisplay + ' of water.';

      resultEl.style.display = 'block';
      resultEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  // Also calculate on Enter key in bottle input
  if (bottleEl) {
    bottleEl.addEventListener('keypress', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        if (calcBtn) calcBtn.click();
      }
    });
  }

})();